export const roleEn = {
  "Role": "Role",
  "Nom du role": "Name of role",
  "Enregistrer": "Save",

  // Server Side

  "Le nom existe deja": "The name already exists",
  "Le nom du role est obligatoire": "The role name is mandatory",
  "Le nom du role doit etre superieur a 3 caracteres": "The role name must be greater than 3 characters",
  

}